export default __webpack_public_path__ + "static/media/dashboard.2caa28d9.svg";